import store from '@/store'
import helper from '@/unit/helper'
export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const permissionList = store.getters && store.getters.permissionList
    if (!value) return el.parentNode && el.parentNode.removeChild(el)
    const hasPermission = helper.arrContains(permissionList,value)
    if (!hasPermission) return el.parentNode && el.parentNode.removeChild(el)
  }
}